import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { MdDashboard, MdPeople, MdApps, MdSettings, MdLogout, MdDescription, MdPayment, MdSupport, MdPersonAdd, MdHub } from 'react-icons/md';
import { FiDollarSign } from 'react-icons/fi';
import logo from '../../assets/notifysphere-logo.png';
import { removeLocalStorage, Utils } from '../../utils';

const AdminSidebar = ({ onLogout }) => {
    const navigate = useNavigate();

    const handleLogout = () => {
        removeLocalStorage(Utils.storageKeys.adminToken);
        removeLocalStorage(Utils.storageKeys.adminData);
        onLogout();
        navigate('/admin/login');
    };

    const menuItems = [
        { path: '/admin/dashboard', icon: <MdDashboard size={20} />, label: 'Dashboard' },
        { path: '/admin/registration-requests', icon: <MdPersonAdd size={20} />, label: 'Registration Requests' },
        { path: '/admin/users', icon: <MdPeople size={20} />, label: 'Platform Users' },
        { path: '/admin/applications', icon: <MdApps size={20} />, label: 'Applications' },
        { path: '/admin/partners', icon: <MdHub size={20} />, label: 'Partners' },
        { path: '/admin/plans', icon: <MdPayment size={20} />, label: 'Plans' },
        { path: '/admin/billing', icon: <FiDollarSign size={20} />, label: 'Billing' },
        { path: '/admin/pages', icon: <MdDescription size={20} />, label: 'Pages' },
        { path: '/admin/support', icon: <MdSupport size={20} />, label: 'Support' },
        // { path: '/admin/roles', icon: <MdSecurity size={20} />, label: 'Team Roles' },
        { path: '/admin/settings', icon: <MdSettings size={20} />, label: 'Settings' },
    ];

    const linkStyle = {
        display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 20px',
        color: '#9ca3af', textDecoration: 'none', borderRadius: '8px', margin: '4px 12px',
        transition: 'all 0.2s'
    };

    const activeLinkStyle = {
        ...linkStyle, background: 'rgba(99, 102, 241, 0.2)', color: '#818cf8'
    };

    return (
        <div style={{
            width: '260px', background: '#1f2937', height: '100vh', position: 'fixed',
            left: 0, top: 0, display: 'flex', flexDirection: 'column'
        }}>
            <div style={{ padding: '20px', borderBottom: '1px solid #374151', textAlign: 'center', flexShrink: 0 }}>
                <img src={logo} alt="Logo" style={{ width: '120px' }} />
                <div style={{ color: '#9ca3af', fontSize: '12px', marginTop: '8px' }}>Admin Panel</div>
            </div>

            {/* flex:1 + minHeight:0 + overflowY:auto — sidebar's own nav scrolls when menu items
                exceed viewport height, while the logo header and Logout footer stay fixed in place. */}
            <nav style={{ flex: 1, minHeight: 0, overflowY: 'auto', paddingTop: '20px' }}>
                {menuItems.map(item => (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        style={({ isActive }) => isActive ? activeLinkStyle : linkStyle}
                    >
                        {item.icon}
                        <span>{item.label}</span>
                    </NavLink>
                ))}
            </nav>

            <div style={{ padding: '20px', borderTop: '1px solid #374151', flexShrink: 0 }}>
                <button
                    onClick={handleLogout}
                    style={{
                        display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 20px',
                        color: '#ef4444', background: 'transparent', border: 'none', cursor: 'pointer',
                        width: '100%', borderRadius: '8px', fontSize: '14px'
                    }}
                >
                    <MdLogout size={20} />
                    <span>Logout</span>
                </button>
            </div>
        </div>
    );
};

export default AdminSidebar;
